<template>
	<!-- Edit mode  -->
	<div v-if="mode === 'edit'" class="action-buttons-wrapper">
		<button
			v-output="lang.get('buttons.save')"
			class="btn btn-secondary btn-sm comment-action-save"
			type="button"
			:disabled="disabled"
			@click="$emit('update')"
		></button>
		<button
			v-output="lang.get('buttons.cancel')"
			class="btn btn-tertiary btn-sm comment-action-cancel"
			type="button"
			:disabled="disabled"
			@click="$emit('cancel')"
		></button>
		<checkbox
			v-if="enableInternalComments"
			name="internalComment"
			:selected="internal"
			:value="internal"
			@change="onChangeInternal"
		>
			<template slot="label">{{ lang.get('comments.visibility.internal.checkbox') }}</template>
		</checkbox>
	</div>
	<!-- View mode  -->
	<div v-else class="inline-block">
		<a
			v-output="lang.get('buttons.edit')"
			href="javascript:;"
			class="comment-action comment-action-edit"
			@click="$emit('edit')"
		></a>
		<span class="comment-delete">
			<a
				v-output="lang.get('buttons.delete')"
				href="javascript:;"
				class="comment-action comment-action-delete"
				@click="$emit('delete')"
			></a>
		</span>
	</div>
</template>

<script>
import { Checkbox } from 'vue-bootstrap';
export default {
	inject: ['lang'],
	components: {
		Checkbox,
	},
	props: {
		mode: {
			type: String,
			required: true,
		},
		comment: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: true,
		},
		token: {
			type: String,
			required: true,
		},
		enableInternalComments: {
			type: Boolean,
			default: false,
		},
		internal: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onChangeInternal(value) {
			this.$emit('changed-internal', value);
		},
	},
};
</script>
